import React, { createContext, useContext, useState, useEffect, useMemo } from "react";
import { ThemeProvider } from "@mui/material";
import { lightTheme } from "./utils/LightTheme";
import { darkTheme } from "./utils/DarkTheme";
import useUser from "../hooks/useUser";

export const ThemeContext = createContext();

export const useThemeContext = () => useContext(ThemeContext);

export const CustomThemeProvider = ({ children }) => {
  const { preference } = useUser();
  const getInitialTheme = () => {
    const storedTheme = localStorage.getItem("theme");
    if (storedTheme) return storedTheme;
    if (preference?.defaultTheme) return preference.defaultTheme;
    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  };

  const [mode, setMode] = useState(getInitialTheme);

  useEffect(() => {
    localStorage.setItem("theme", mode);
  }, [mode]);

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };

  const setTheme = (val) => {
    setMode(val.toLowerCase());
  };

  const contextValue = useMemo(
    () => ({ toggleTheme, mode, setTheme }),
    [mode]
  );

  return (
    <ThemeContext.Provider value={contextValue}>
      <ThemeProvider theme={mode === "dark" ? darkTheme : lightTheme}>
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};
